import { lazy, Suspense } from 'react';
import Loader from './Loader';

interface HtmlEditorProps {
  data?: string;
  onChange?: (html: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const LexicalEditor = lazy(() => import('./lexical/LexicalEditor'));

const HtmlEditor = ({
  data = '',
  placeholder = '',
  onChange,
  disabled = false,
}: HtmlEditorProps) => (
  <Suspense fallback={<Loader inline />}>
    <LexicalEditor
      data={data}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
    />
  </Suspense>
);

export default HtmlEditor;
